import { Button } from "primereact/button";
import { useFormState } from "react-hook-form";

export function ContinueButton({
  onClick,
  loading,
  disabled,
  children = "Continue",
  variant = "primary",
  className = "",
}: {
  onClick: () => void;
  loading: boolean;
  disabled: boolean;
  children?: React.ReactNode;
  variant?: "primary" | "secondary";
  className?: string;
}) {
  const { isValid } = useFormState();
  return (
    <Button
      className={`w-full justify-content-center border-round-lg mt-3 ${
        variant === "secondary" ? "p-button-outlined " : ""
      } ${className}`.trim()}
      onClick={onClick}
      disabled={!isValid || disabled}
      loading={loading}
    >
      {children}
    </Button>
  );
}
